import { PostgrestClient } from '@supabase/postgrest-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const serviceKey = import.meta.env.VITE_SUPABASE_SERVICE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

const headers = {
  Authorization: `Bearer ${serviceKey}`,
  apikey: serviceKey,
  'Content-Type': 'application/json',
};

const postgrest = new PostgrestClient(`${supabaseUrl}/rest/v1`, { headers });

export const supabaseAdmin = {
  from: (table: string) => postgrest.from(table),
  auth: {
    admin: {
      async createUser(attrs: Record<string, unknown>) {
        const res = await fetch(`${supabaseUrl}/auth/v1/admin/users`, {
          method: 'POST',
          headers,
          body: JSON.stringify(attrs),
        });
        const json = await res.json();
        if (!res.ok) return { data: null, error: json };
        return { data: { user: json }, error: null };
      },
      async deleteUser(id: string) {
        const res = await fetch(`${supabaseUrl}/auth/v1/admin/users/${id}`, {
          method: 'DELETE',
          headers,
        });
        if (!res.ok) {
          const json = await res.json();
          return { data: null, error: json };
        }
        return { data: {}, error: null };
      },
      async getUser(id: string) {
        const res = await fetch(`${supabaseUrl}/auth/v1/admin/users/${id}`, {
          method: 'GET',
          headers,
        });
        const json = await res.json();
        if (!res.ok) return { data: null, error: json };
        return { data: { user: json }, error: null };
      },
    },
  },
};
